import { BaseService } from './base.service';
import {
  Playlist,
  PlaylistFormData,
  PlaylistListParams,
  PlaylistListResult,
} from '@/types/playlist';

class PlaylistService extends BaseService {
  constructor() {
    super('/content-library/playlists');
  }

  async listPlaylists(params: PlaylistListParams): Promise<PlaylistListResult> {
    const query = new URLSearchParams();
    if (params.offset !== undefined) query.set('offset', String(params.offset));
    if (params.limit !== undefined) query.set('limit', String(params.limit));
    if (params.status) query.set('status', params.status);
    if (params.search) query.set('search', params.search);
    const qs = query.toString();
    return this.get<PlaylistListResult>(qs ? `?${qs}` : '');
  }

  async getPlaylist(id: string): Promise<Playlist> {
    return this.get<Playlist>(`/${id}`);
  }

  async createPlaylist(data: PlaylistFormData): Promise<Playlist> {
    return this.post<Playlist>('', data);
  }

  async updatePlaylist(id: string, data: PlaylistFormData): Promise<Playlist> {
    return this.put<Playlist>(`/${id}`, data);
  }

  async reorderPlaylist(id: string, contentItemIds: string[]): Promise<Playlist> {
    return this.patch<Playlist>(`/${id}/reorder`, { contentItemIds });
  }

  async publishPlaylist(id: string): Promise<Playlist> {
    return this.post<Playlist>(`/${id}/publish`);
  }

  async unpublishPlaylist(id: string): Promise<Playlist> {
    return this.post<Playlist>(`/${id}/unpublish`);
  }

  async deletePlaylist(id: string): Promise<void> {
    return this.delete<void>(`/${id}`);
  }
}

export const playlistService = new PlaylistService();
